module.exports = __webpack_public_path__ + "entry-150bfe9b/duerenhoff-photo-120c095c7885bdc427ad10344d1ac8d2.webp";